module.exports = __webpack_public_path__ + "static/media/comment-alt-exclamation.6cf81c2b.svg";